<template>
  <div class="mt-3">
    <!-- Prepaid Credit Image -->
    <smart-image :imageURL="imageURL" class="style-img" />

    <!-- Price and quantity -->
    <div class="my-3 ms-4" v-if="!hidePrice">
      <div
        class="text-start scss-text-blue scss-bold style-promotion-price"
        v-if="salePriceVisibility"
      >
        {{ `${branchCurrencySymbol} ${getFormattedNumber(salePrice)}` }}
      </div>
      <div
        class="text-decoration-line-through text-start style-price"
        v-if="originalPrice"
      >
        {{ `${branchCurrencySymbol} ${getFormattedNumber(originalPrice)}` }}
      </div>
    </div>

    <list-header :title="name" class="mt-2" />
  </div>
</template>

<script>
// import InputSpinner from "./InputSpinner.vue";

import { getFormattedNumber } from "@/common/helpers/PriceHelper.js";
import SmartImage from "@/components/SmartImage.vue";
import { mapGetters } from "vuex";
import ListHeader from "@/components/ListHeader.vue";

export default {
  name: "Item Info Container",
  components: { SmartImage, ListHeader },
  props: {
    imageURL: String,
    salePrice: [String, Number],
    salePriceVisibility: {
      type: Boolean,
      default: true,
    },
    originalPrice: String,
    hidePrice: {
      type: [Boolean, Number],
      default: false,
    },
    name: String,
  },
  methods: {
    getFormattedNumber,
  },
  computed: {
    ...mapGetters(["branchCurrencySymbol"]),
  },
};
</script>

<style lang="scss" scoped>
.style-img {
  width: 92.5%;
  height: 200px;
  margin: auto;
  border-radius: 2.5%;
}

.style-price {
  font-weight: $font-bold;
  color: $text-light-color;
  font-size: $medium-font-size;
}

.style-promotion-price {
  font-size: 20px;
}
</style>
